/**
 * Один словарь статусов урока на все три поверхности.
 * Подпись — то, что читает человек; код остаётся рядом, чтобы его можно было назвать в поддержке.
 */
export type LessonStatusTone = "neutral" | "live" | "done" | "quiet" | "alarm";

interface LessonStatusView {
  readonly label: string;
  readonly tone: LessonStatusTone;
}

const VIEWS: Record<string, LessonStatusView> = {
  scheduled: { label: "Записан", tone: "neutral" },
  client_arrived: { label: "На площадке", tone: "live" },
  completed: { label: "Проведён", tone: "done" },
  canceled: { label: "Отменён", tone: "quiet" },
  no_show: { label: "Не пришёл", tone: "alarm" },
};

export function lessonStatusLabel(status: string): string {
  return VIEWS[status]?.label ?? status;
}

export function lessonStatusTone(status: string): LessonStatusTone {
  return VIEWS[status]?.tone ?? "neutral";
}

/** Классы бейджа статуса — плоская краска, без колец и градиентов. */
export function lessonStatusBadgeClass(status: string): string {
  switch (lessonStatusTone(status)) {
    case "live":
      return "bg-hivis-100 text-hivis-700";
    case "done":
      return "bg-ok-100 text-ok-500";
    case "quiet":
      return "bg-ink-100 text-ink-700";
    case "alarm":
      return "bg-danger-100 text-danger-500";
    default:
      return "bg-ink-950 text-white";
  }
}

/** Модификатор жёлтой полосы .pwz-mark для строки/карточки урока. */
export function lessonStatusMarkClass(status: string): string {
  switch (lessonStatusTone(status)) {
    case "live":
      return "pwz-mark";
    case "done":
      return "pwz-mark pwz-mark--ok";
    case "quiet":
      return "pwz-mark pwz-mark--quiet";
    case "alarm":
      return "pwz-mark pwz-mark--danger";
    default:
      return "pwz-mark pwz-mark--ink";
  }
}
